export default __webpack_public_path__ + "static/media/apple-1838564.92aaea6c.jpg";